import script from "./LeagueStandingsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./LeagueStandingsView.vue?vue&type=script&lang=ts&setup=true"

import "./LeagueStandingsView.vue?vue&type=style&index=0&id=eb7ad1c0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb7ad1c0"]])

export default __exports__